import { fromSpecific, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { TRecord } from '@rehaje/shared'

export class WidgetNode extends TypedNode {
  @fromSpecific()
  @reactive('shallow')
  children: TypedNode[] = []

  @fromSpecific()
  @reactive()
  hidden?: boolean

  @fromSpecific()
  @reactive('deep')
  props?: TRecord

  @fromSpecific()
  @reactive()
  ref?: boolean

  override evaluateTraverse(_visitor: (node: TypedNode) => boolean | void) {
    // 附属节点不参与递归计算，避免重复计算，交给父节点来计算
    return
  }
}
